import React from 'react';
import { compose } from 'redux';
import { connect } from 'react-redux';

import { isMobileUA } from 'dpl/shared/utils';
import withRotatingContent from 'dpl/decorators/withRotatingContent';
import SoftwareSectionV3 from 'dpl/join_as_breeder/components/SoftwareSectionV3';
import MobileSoftwareSectionV3 from 'dpl/join_as_breeder/components/MobileSoftwareSectionV3';

function SoftwareSectionV3Container(props) {
  return isMobileUA() ? (
    <MobileSoftwareSectionV3 {...props} />
  ) : (
    <SoftwareSectionV3 {...props} />
  );
}

export default compose(
  connect(({ server }) => ({
    softwareItems: server.pageSections.software.page_items,
    rotatingContentCount: server.pageSections.software.page_items.length
  })),
  withRotatingContent
)(SoftwareSectionV3Container);
